import type { SVGProps } from 'react';

const SvgAnnotationRectangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 21H6c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3h12c1.65 0 3 1.35 3 3v12c0 1.65-1.35 3-3 3M6 5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
    />
  </svg>
);
export default SvgAnnotationRectangle;
